import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { AsyncSelect, Select } from '../../components/Form';
import { REQUIRED_TEXT_MESSAGE } from '../../utils/constants';
import AnimateHeight from 'react-animate-height';
import {
  organizationMembershipAdminCreate,
  organizationMembershipAdminList,
  organizationMembershipCourseCreatorCreate,
  organizationMembershipCourseCreatorList,
} from '../store/action/organizationMembership';
import qs from 'query-string';
import OrganizationMembershipList from '../../components/OrganizationMembershipList';
import Loader from '../../components/Loader';
import { Link } from 'react-router-dom';
import { incomingInstructorConnectionDemandList, instructorConnectionList } from '../store/action/organization';
import IncomingInstructorConnectionDemandList from '../../components/IncomingInstructorConnectionDemandList';
import { getAddUserInOrgOptions } from '../../utils/PermissionManager';

export default function OrganizationSingle({ history }) {
  let { search, pathname } = history.location;
  const qps = qs.parse(search);
  const [queryParams, setQueryParams] = useState({
    orgAdminPage: 1,
    orgCourseCreatorPage: 1,
    instructorDemandPage: 1,
    instructorConnectionPage: 1,
    ...qps,
  });

  let [height, setHeight] = useState(0);

  let listOfOrganizationMembershipAdmin = useSelector(state => state.organizationMembership.admin.list);
  let listOfOrganizationMembershipCourseCreator = useSelector(state => state.organizationMembership.courseCreator.list);
  let listOfIncomingInstructorConnectionDemand = useSelector(
    state => state.organization.incomingInstructorConnectionDemand.list
  );
  let listOfInstructorConnection = useSelector(state => state.organization.instructorConnection.list);

  let detailOfOrganizationMembershipAdmin = useSelector(state => state.organizationMembership.admin);
  let detailOfOrganizationMembershipCourseCreator = useSelector(state => state.organizationMembership.courseCreator);

  let isRenderedOrganizationMembershipAdmins =
    listOfOrganizationMembershipAdmin.data && !listOfOrganizationMembershipAdmin.isLoading;
  let isRenderedOrganizationMembershipCourseCreators =
    listOfOrganizationMembershipCourseCreator.data && !listOfOrganizationMembershipCourseCreator.isLoading;
  let isRenderedIncomingInstructorConnectionDemands =
    listOfIncomingInstructorConnectionDemand.data && !listOfIncomingInstructorConnectionDemand.isLoading;
  let isRenderedInstructorConnection = listOfInstructorConnection.data && !listOfInstructorConnection.isLoading;

  let loading =
    listOfOrganizationMembershipAdmin.isLoading ||
    listOfOrganizationMembershipCourseCreator.isLoading ||
    detailOfOrganizationMembershipAdmin.isLoading ||
    detailOfOrganizationMembershipCourseCreator.isLoading;

  // let permissionLS = JSON.parse(localStorage.getItem('permission'));

  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);

  let { control, handleSubmit, errors, reset } = useForm();

  let dispatch = useDispatch();

  const handleToggleHeight = () => setHeight(height ? 0 : 'auto');

  const handlePageChange = (page, name) => {
    setQueryParams({ ...queryParams, [name]: page });
  };

  function onSubmit(data) {
    let dataResult = { user: data.user.value, organization_id: selectedOrg.id };

    if (data.role.value === 'admin') dispatch(organizationMembershipAdminCreate(dataResult)).then(() => setHeight(0));
    else dispatch(organizationMembershipCourseCreatorCreate(dataResult)).then(() => setHeight(0));
  }

  useEffect(() => {
    let paramsAPI = {};
    let paramsRouter = {};

    paramsAPI['page'] = queryParams.orgAdminPage;
    if (queryParams.orgAdminPage > 1) paramsRouter['orgAdminPage'] = queryParams.orgAdminPage;
    if (queryParams.orgCourseCreatorPage > 1) paramsRouter['orgCourseCreatorPage'] = queryParams.orgCourseCreatorPage;
    if (queryParams.instructorDemandPage > 1) paramsRouter['instructorDemandPage'] = queryParams.instructorDemandPage;
    if (queryParams.instructorConnectionPage > 1)
      paramsRouter['instructorConnectionPage'] = queryParams.instructorConnectionPage;

    let paramsString = qs.stringify(paramsRouter);
    paramsString = !!paramsString ? `?${paramsString}` : '';
    history.push(`${pathname}${paramsString}`);

    dispatch(organizationMembershipAdminList(paramsAPI));
    /* eslint-disable-next-line */
  }, [queryParams.orgAdminPage, detailOfOrganizationMembershipAdmin.data, selectedRole, selectedOrg]);

  useEffect(() => {
    let paramsAPI = {};
    let paramsRouter = {};

    paramsAPI['page'] = queryParams.orgCourseCreatorPage;
    if (queryParams.orgCourseCreatorPage > 1) paramsRouter['orgCourseCreatorPage'] = queryParams.orgCourseCreatorPage;
    if (queryParams.orgAdminPage > 1) paramsRouter['orgAdminPage'] = queryParams.orgAdminPage;
    if (queryParams.instructorDemandPage > 1) paramsRouter['instructorDemandPage'] = queryParams.instructorDemandPage;
    if (queryParams.instructorConnectionPage > 1)
      paramsRouter['instructorConnectionPage'] = queryParams.instructorConnectionPage;

    let paramsString = qs.stringify(paramsRouter);
    paramsString = !!paramsString ? `?${paramsString}` : '';
    history.push(`${pathname}${paramsString}`);

    dispatch(organizationMembershipCourseCreatorList(paramsAPI));
  }, [queryParams.orgCourseCreatorPage, detailOfOrganizationMembershipCourseCreator.data, selectedRole, selectedOrg]);

  useEffect(() => {
    let paramsAPI = {};
    let paramsRouter = {};

    paramsAPI['page'] = queryParams.instructorDemandPage;
    if (queryParams.instructorDemandPage > 1) paramsRouter['instructorDemandPage'] = queryParams.instructorDemandPage;
    if (queryParams.orgCourseCreatorPage > 1) paramsRouter['orgCourseCreatorPage'] = queryParams.orgCourseCreatorPage;
    if (queryParams.orgAdminPage > 1) paramsRouter['orgAdminPage'] = queryParams.orgAdminPage;
    if (queryParams.instructorConnectionPage > 1)
      paramsRouter['instructorConnectionPage'] = queryParams.instructorConnectionPage;

    let paramsString = qs.stringify(paramsRouter);
    paramsString = !!paramsString ? `?${paramsString}` : '';
    history.push(`${pathname}${paramsString}`);

    dispatch(incomingInstructorConnectionDemandList(paramsAPI));
  }, [queryParams.instructorDemandPage, selectedRole, selectedOrg]);

  useEffect(() => {
    let paramsAPI = {};
    let paramsRouter = {};

    paramsAPI['page'] = queryParams.instructorConnectionPage;
    if (queryParams.instructorConnectionPage > 1)
      paramsRouter['instructorConnectionPage'] = queryParams.instructorConnectionPage;
    if (queryParams.instructorDemandPage > 1) paramsRouter['instructorDemandPage'] = queryParams.instructorDemandPage;
    if (queryParams.orgCourseCreatorPage > 1) paramsRouter['orgCourseCreatorPage'] = queryParams.orgCourseCreatorPage;
    if (queryParams.orgAdminPage > 1) paramsRouter['orgAdminPage'] = queryParams.orgAdminPage;

    let paramsString = qs.stringify(paramsRouter);
    paramsString = !!paramsString ? `?${paramsString}` : '';
    history.push(`${pathname}${paramsString}`);

    dispatch(instructorConnectionList(paramsAPI));
  }, [queryParams.instructorConnectionPage, selectedRole, selectedOrg]);

  return (
    <Fragment>
      <div className="kt-portlet p-3">
        <div className="kt-portlet__body pt-0">
          <Row>
            <Col xs={12}>
              <div className={'d-flex justify-content-end'}>
                <Button onClick={handleToggleHeight}>
                  {height ? <i className="fas fa-minus" /> : <i className="fas fa-plus" />}
                  اضافه کردن کاربر
                </Button>
                <Link to={`/orgs/${selectedOrg.id}`}>
                  <Button className={'ml-2'}>
                    <i className="fas fa-pen" />
                    ویرایش سازمان
                  </Button>
                </Link>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={{ span: 12, order: 2 }} xl={{ span: 8, order: 1 }}>
              {isRenderedOrganizationMembershipAdmins && (
                <OrganizationMembershipList
                  organizationMembershipList={listOfOrganizationMembershipAdmin}
                  count={listOfOrganizationMembershipAdmin.count}
                  onPageChange={handlePageChange}
                  type={'admin'}
                  currentPage={parseInt(queryParams.orgAdminPage)}
                  pageParamName={'orgAdminPage'}
                  title={'مدیران سازمان'}
                />
              )}
              {isRenderedOrganizationMembershipCourseCreators && (
                <OrganizationMembershipList
                  organizationMembershipList={listOfOrganizationMembershipCourseCreator}
                  count={listOfOrganizationMembershipCourseCreator.count}
                  onPageChange={handlePageChange}
                  type={'courseCreator'}
                  currentPage={parseInt(queryParams.orgCourseCreatorPage)}
                  pageParamName={'orgCourseCreatorPage'}
                  title={'دوره سازهای سازمان'}
                />
              )}
              {isRenderedInstructorConnection && (
                <OrganizationMembershipList
                  organizationMembershipList={listOfInstructorConnection}
                  count={listOfInstructorConnection.count}
                  onPageChange={handlePageChange}
                  type={'instructor'}
                  currentPage={parseInt(queryParams.instructorConnectionPage)}
                  pageParamName={'instructorConnectionPage'}
                  title={'استادهای سازمان'}
                />
              )}
            </Col>
            <Col xs={{ span: 12, order: 1 }} xl={{ span: 4, order: 2 }}>
              {height ? (
                <Card className={'my-3 p-3'}>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <AsyncSelect
                      control={control}
                      name={'user'}
                      error={errors?.user?.message}
                      optionPattern={{ label: 'username', value: 'id' }}
                      apiPath={'/manage/users/'}
                      queryParam={'search'}
                      label={'انتخاب کاربر'}
                      rules={{ required: REQUIRED_TEXT_MESSAGE }}
                      customLabel={item => `${item.first_name} ${item.last_name}(${item.username})`}
                    />

                    <div className={'mt-3'}>
                      <Select
                        control={control}
                        name={'role'}
                        options={getAddUserInOrgOptions(selectedRole)}
                        label={'نقش'}
                        rules={{ required: REQUIRED_TEXT_MESSAGE }}
                        isClearable
                        error={errors?.role?.message}
                      />
                    </div>
                    <div className={'d-flex justify-content-end'}>
                      <Button type={'submit'}>
                        <i className="fas fa-check" />
                        ایجاد نقش
                      </Button>
                    </div>
                  </Form>
                </Card>
              ) : (
                ''
              )}
              {isRenderedIncomingInstructorConnectionDemands && (
                <IncomingInstructorConnectionDemandList
                  incomingInstructorConnectionDemandList={listOfIncomingInstructorConnectionDemand}
                  count={listOfIncomingInstructorConnectionDemand.count}
                  onPageChange={handlePageChange}
                  currentPage={parseInt(queryParams.instructorDemandPage)}
                  pageParamName={'instructorDemandPage'}
                  title={'درخواست های استاد شدن'}
                />
              )}
            </Col>
          </Row>
        </div>
      </div>
      <Loader visible={loading} />
    </Fragment>
  );
}
